import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ClienteService } from '../../cliente/cliente.service';
import { VehiculoService } from '../vehiculo.service';

@Component({
  selector: 'app-vehiculo-view',
  templateUrl: './vehiculo-view.component.html',
  styleUrls: ['./vehiculo-view.component.scss']
})
export class VehiculoViewComponent implements OnInit {

  @Input() element: any;
  
  form: FormGroup = new FormGroup({});
  clientes: any[] = [];

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: VehiculoService,
    public formatter: FormatterService,
    private clienteService: ClienteService,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: ['', [Validators.required]],
      patente: ['', [Validators.required]],
      marca: ['', [Validators.required]],
      modelo: ['', [Validators.required]],
      year: ['', [Validators.required]],
      unidad_medida: [0, [Validators.required]],
      usuario_id: [null],
    });
    this.form.patchValue(this.element);
    this.getClientes();
    this.form.disable();
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.update(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Vehículo actualizado con éxito.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo actualizar el registro de vehículo.", "danger");
          if (err.error.msg) {
            this.alerts.addAlert(err.error.msg, "danger");
          }
          if (err.error.errors[0]) {
            this.alerts.addAlert(err.error.errors[0].msg, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  getClientes(): void {
    this.loading.show();
    this.clienteService.index_select().subscribe({
      next: (res) => {
        this.loading.hide();
        this.clientes = res;
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo obtener la lista de clientes.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  searchFn(term: any, item: any) {
    const removeAccents = (str: string) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre].join(' ')).toLowerCase());
    terms.forEach(t => {
      result = result && p.includes(t);
    });
    return result;
  }
}
